import type { FunctionComponent } from 'react';
import { Modal } from '@fff-web/fff-ui-shared';
import useFingerPrint from '../../utils/fingerPrintHook';
import SubmissionForm from '../SubmissionForm/SubmissionForm';
import * as styles from './SubmissionModal.module.scss';

type SubmissionModalProps = {
  isOpen: boolean;
  brandName: string;
  name: string;
  imgUrl: string;
  productId: number;
  defaultRating?: number;
  context: string;
  sku: string;
  onSuccess: (response: unknown) => void;
  closeModal: () => void;
  env: 'dev' | 'prod';
};

const SubmissionModal: FunctionComponent<SubmissionModalProps> = ({
  isOpen,
  brandName,
  name,
  imgUrl,
  productId,
  defaultRating,
  context,
  sku,
  onSuccess,
  closeModal,
  env,
}) => {
  const [fingerPrint] = useFingerPrint(env);

  return (
    <Modal className={styles.modal} isOpen={isOpen}>
      <SubmissionForm
        brandName={brandName}
        name={name}
        imgUrl={imgUrl}
        productId={productId}
        defaultRating={defaultRating}
        onSuccess={onSuccess}
        closeModal={closeModal}
        env={env}
        sku={sku}
        fingerPrint={fingerPrint}
        context={context}
      />
    </Modal>
  );
};

export default SubmissionModal;
